<template>
  <b-sidebar
    id="sidebar"
    shadow
    no-header
    :visible="isVisible"
    z-index="99"
    no-close-on-route-change
    :right="isMobile"
    :backdrop="isMobile"
    class="sidebar"
  >
    <nav class="mt-3 mt-md-0 pt-5 p-md-0">
      <ul class="nav flex-column pt-2">
        <li class="nav-item" v-if="isAdmin">
          <router-link :to="{ name: '商品管理' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >商品管理</a
            >
          </router-link>
        </li>
        <li class="nav-item" v-if="isAdmin">
          <router-link
            :to="{ name: '業務區域管理' }"
            v-slot="{ href, isActive }"
          >
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >業務區域管理</a
            >
          </router-link>
        </li>
        <li class="nav-item" v-show="isAdmin">
          <a
            v-b-toggle.nav-item-collapse
            variant="link"
            class="py-3 nav-link d-flex justify-content-between align-items-center"
            :class="{ active: navItemChildShow }"
            href="javascript:;"
          >
            <span>帳號管理</span>
            <b-icon-chevron-down v-if="navItemChildShow"></b-icon-chevron-down>
            <b-icon-chevron-right v-else></b-icon-chevron-right>
          </a>
          <b-collapse
            id="nav-item-collapse"
            class="nav-item-child"
            :visible="navItemChildShow"
            @show="OnNavItemChildShow"
            @hide="OnNavItemChildHide"
          >
            <ul class="nav flex-column">
              <li class="nav-item">
                <router-link :to="{ name: '業務' }" v-slot="{ href, isActive }">
                  <a
                    class="nav-link py-3 pl-4"
                    :class="{ active: isActive }"
                    :href="href"
                    >業務</a
                  >
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: '管理者' }"
                  v-slot="{ href, isActive }"
                >
                  <a
                    class="nav-link py-3  pl-4"
                    :class="{ active: isActive }"
                    :href="href"
                    >管理者</a
                  >
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '訂單管理' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >訂單管理</a
            >
          </router-link>
        </li>
        <li class="nav-item" v-show="isAdmin">
          <router-link :to="{ name: '報表' }" v-slot="{ href, isActive }">
            <a class="nav-link py-3" :class="{ active: isActive }" :href="href"
              >報表</a
            >
          </router-link>
        </li>
      </ul>
    </nav>
  </b-sidebar>
</template>

<style lang="scss" scoped>
.sidebar ::v-deep .b-sidebar {
  background-color: #f5fff6 !important;
  .active {
    color: $cms_main;
  }
}
.nav-item-child {
  background-color: #e6f7e5;
  .active {
    background-color: #e6f7e5;
    &::after {
      background-color: $cms_main;
    }
  }
}
</style>

<script>
export default {
  name: "Sidebar",
  props: ["isMobile", "isAdmin"],
  data() {
    return {
      isVisible: true,
      navItemChildShow: false
    };
  },
  watch: {
    isMobile(data) {
      if (data) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  },
  methods: {
    hasClass(ele, cls) {
      return (" " + ele.className + " ").indexOf(" " + cls + " ") > -1;
    },
    OnNavItemChildShow() {
      this.navItemChildShow = true;
    },
    OnNavItemChildHide() {
      this.navItemChildShow = false;
    }
  },
  mounted() {
    const vm = this;
    if (vm.isMobile) {
      vm.isVisible = false;
    } else {
      vm.isVisible = true;
    }
    this.$nextTick(function() {
      const navItemChilds = document.querySelectorAll(
        ".nav-item-child .nav-link"
      );
      [].forEach.call(navItemChilds, ele => {
        if (this.hasClass(ele, "active")) {
          this.navItemChildShow = true;
        }
      });
    });
  }
};
</script>
